function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 10,
  fill: "#181818"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2656 11H15V54H49.2656V11Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_20046460_140663)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.1702 14.8685L48.1414 23.6082C48.905 24.3506 49.2809 25.1017 49.269 25.8587C49.2572 26.6156 48.9287 27.3055 48.2864 27.9315C47.6145 28.5865 46.8894 28.9185 46.1139 28.933C45.3384 28.9447 44.5689 28.5778 43.8052 27.8355L34.6299 18.8977C33.588 17.8817 32.5817 17.1626 31.6138 16.7404C30.6459 16.3183 29.6278 16.2513 28.5623 16.5425C27.4938 16.8307 26.3484 17.5731 25.12 18.7667C23.427 20.4174 22.619 21.9662 22.7019 23.4132C22.7847 24.8601 23.6253 26.3623 25.2207 27.9141L34.47 36.9275C35.2426 37.6786 35.6214 38.4296 35.6095 39.175C35.5977 39.9232 35.2662 40.6132 34.6121 41.2507C33.961 41.8854 33.2417 42.2173 32.4603 42.2435C31.6789 42.2697 30.9005 41.9058 30.1309 41.1546L21.1598 32.4149C19.7006 30.9942 18.6469 29.6492 17.9987 28.3798C17.3505 27.1105 17.1078 25.6752 17.2765 24.074C17.4275 22.7028 17.8744 21.3752 18.6203 20.0885C19.3632 18.8016 20.4287 17.4857 21.811 16.1378C23.4566 14.5337 25.0283 13.3051 26.5259 12.4492C28.0207 11.5932 29.4679 11.1187 30.865 11.0197C32.265 10.9207 33.6442 11.1944 35.0087 11.8407C36.3732 12.487 37.7584 13.4943 39.1673 14.8685H39.1702Z",
  fill: "url(#paint0_linear_20046460_140663)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0961 50.1326L16.128 41.3929C15.3643 40.6476 14.9884 39.8994 15.0003 39.1424C15.0121 38.3855 15.3406 37.6956 15.9829 37.0696C16.6548 36.4146 17.38 36.0827 18.1554 36.0681C18.9309 36.0565 19.7004 36.4203 20.4641 37.1657L29.6365 46.1034C30.6813 47.1194 31.6847 47.8385 32.6525 48.2607C33.6204 48.6828 34.6386 48.7468 35.7071 48.4586C36.7755 48.1704 37.9209 47.428 39.1493 46.2315C40.8423 44.5807 41.6503 43.0319 41.5675 41.585C41.4846 40.1381 40.644 38.6359 39.0487 37.0813L34.1206 32.3212C33.3481 31.5701 32.9692 30.819 32.9811 30.0737C32.9929 29.3255 33.3244 28.6355 33.9785 27.998C34.6297 27.3633 35.3489 27.0314 36.1303 27.0052C36.9117 26.979 37.6901 27.3429 38.4597 28.0941L43.1065 32.5804C44.5657 34.0011 45.6194 35.3461 46.2676 36.6155C46.9158 37.8848 47.1585 39.32 46.9898 40.9212C46.8389 42.2925 46.3919 43.62 45.646 44.9069C44.9031 46.1936 43.8376 47.5096 42.4554 48.8575C40.8097 50.4616 39.2381 51.6902 37.7404 52.5461C36.2427 53.4021 34.7955 53.8795 33.3955 53.9785C31.9955 54.0775 30.6162 53.8038 29.2517 53.1575C27.8872 52.5111 26.502 51.5039 25.0932 50.1298L25.0961 50.1326Z",
  fill: "url(#paint1_linear_20046460_140663)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.6908 27.5821C32.5101 27.5821 33.985 26.1314 33.985 24.3418C33.985 22.5523 32.5101 21.1016 30.6908 21.1016C28.8714 21.1016 27.3965 22.5523 27.3965 24.3418C27.3965 26.1314 28.8714 27.5821 30.6908 27.5821Z",
  fill: "url(#paint2_radial_20046460_140663)"
}));
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20046460_140663",
  x1: 46.6659,
  y1: 19.9603,
  x2: 19.0171,
  y2: 32.4522,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#201C1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#77390D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#EA8101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4B852"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20046460_140663",
  x1: 18.3689,
  y1: 45.4009,
  x2: 50.4986,
  y2: 35.6791,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1F1D1C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#77390D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#EA8101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FB52"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_20046460_140663",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.6908 24.3448) scale(3.29426 3.24029)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4B852"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#EA8101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#77390D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#211C1D"
})));
function SvgUnisat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20046460_140663",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 11,
    width: 35,
    height: 43
  }, _ref3), _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisat);
export default __webpack_public_path__ + "static/media/unisat.abc90dcbc1718e98882b613a777b3952.svg";
export { ForwardRef as ReactComponent };